<template>
  <v-card class="d-flex flex-wrap flex-md-nowrap flex-column flex-md-row justify-md-space-between pa-3">
    <v-badge v-if="hasProductBoost" bordered icon="mdi-rocket-launch" left overlap color="red" class="rocket-boost"/>
    <div class="d-flex flex-md-row align-center justify-md-start flex-grow-1 flex-row-reverse justify-space-between mr-md-5">
      <v-checkbox dense class="align-center justify-center ma-0 pa-0" :input-value="section.confirmed" hide-details
                  :disabled="isConfirmationDisabled" @click="onConfirm"/>
      <div class="font-weight-bold">{{ sectionName }}</div>
    </div>
    <section-chips :group-info="section" :default-width="90" class="d-flex flex-row align-center justify-center"
                   v-on="$listeners"/>
  </v-card>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { MapActions, MapGetters } from '@core/helpers/decorators';
import ChipGroup from '@optimizer/components/ChipGroup';
import { SectionRecommendation } from '../models';
import SectionChips from './SectionChips.vue';

@Component({ components: { SectionChips, ChipGroup } })
@MapGetters(['menuRecommendation', 'getSectionProfitability', 'boostedMenuProductSet',
  'optimizerLanguage'])
@MapActions(['setMenuEngineeringSectionConfirmed'])
export default class SectionCard extends Vue {
  @Prop({ type: SectionRecommendation, required: true }) section;

  @Prop({ type: Boolean, default: false }) confirmationDisabled;

  @Prop({ type: Boolean, default: false }) isRecommendationEditable;

  sectionName = ''

  get hasProductBoost() {
    return [...this.section.menuProductGuids].some((guid) => this.boostedMenuProductSet.has(guid));
  }

  get isConfirmationDisabled() {
    return this.hasProductBoost || !this.isRecommendationEditable;
  }

  get sectionProfitability() {
    const sectionProfitability = this.getSectionProfitability(this.menuRecommendation.guid, this.section.guid);
    if (sectionProfitability) {
      if (sectionProfitability.profitability > 0.25) return 5;
      if (sectionProfitability.profitability > 0.20) return 4;
      if (sectionProfitability.profitability > 0.15) return 3;
      if (sectionProfitability.profitability > 0.10) return 2;
      if (sectionProfitability.profitability > 0.0) return 1;
    }
    return 0;
  }

  get sectionProfitabilityColor() {
    if (this.sectionProfitability === 0) return 'red';
    return 'var(--v-primary-base)';
  }

  get sectionProfitabilityWidth() {
    if (this.$vuetify.breakpoint.smAndDown) return 100;
    return 30;
  }

  async onConfirm() {
    const sectionGuid = this.section.guid;
    const confirmed = !this.section.confirmed;
    await this.setMenuEngineeringSectionConfirmed({ sectionGuid, confirmed });
    this.$emit('confirmation-changed', sectionGuid);
  }

  @Watch('optimizerLanguage', { immediate: true })
  onOptimizerLanguage(newLanguage) {
    const newText = this.section[`name${newLanguage.charAt(0).toUpperCase() + newLanguage.slice(1)}`];
    if (newText !== '') {
      this.sectionName = newText;
    }
  }
}
</script>

<style>
.greyed-out {
  -webkit-text-fill-color: lightgray;
  -webkit-text-stroke: 1px lightgray;
  opacity: 0.3;
}
</style>

<style scoped>
.rocket-boost {
  position: absolute;
  top: 2px;
  left: 2px;
}
</style>
